import { render } from "./CompletedTraining.vue?vue&type=template&id=b8ae4668&scoped=true"
import script from "./CompletedTraining.vue?vue&type=script&lang=js"
export * from "./CompletedTraining.vue?vue&type=script&lang=js"

import "./CompletedTraining.vue?vue&type=style&index=0&id=b8ae4668&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ae4668"]])

export default __exports__